import { jwtDecode } from "jwt-decode";

interface DecodedToken {
  email: string;
  sub: number;
  role: string;
  iat: number;
  exp: number;
}

export const decodeToken = (token: string): DecodedToken | null => {
  try {
    return jwtDecode(token);
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
};